const CV = () => {
  return (
    <div style={{ maxWidth: "800px" }}>
      <h1 class="title">George Garman</h1>
      <h3>Profile</h3>
      <p>
        I am an experienced programmer with strong maths skills, aspiring to
        have a successful career in technology.
      </p>
      <h3>Experience</h3>
      <h4>Jun 2023 - Jun 2024 - Full-stack developer, Software Engineer – Web Development Industrial Placement , UKRI-STU</h4>
Worked in a software engineering team for user accounts and authentication. Java backend and NextJS frontend development with NextJs.
Contributed to the development and maintenance of a Java-based backend system
Designed, implemented, and tested REST APIs 
Gained practical experience in version control, code reviews, and CI/CD workflows
Developed and maintained frontend features using Next.js, React, and TypeScript
Gained soft skills such as time management, problem-solving, and effective communication through daily standups, sprint planning, and collaborative debugging sessions.
      <h4>Jun - Sept 2022 - Full-stack intern, Centella</h4>
      <p>
        Worked on a web application that provides a service to support
        scientific researchers in editing and publishing their work. The
        internship involved a mixture of learning and implementation of that
        learning.
      </p>
      <h5>Projects</h5>
      <ul>
        <li>
          Designed a role-based authentication system microservice that used
          node, express, mongoose, bcrypt and jwt authentication.
        </li>
        <li>
          Designed a service for user profiles, where users could raise
          complaints and give ratings to other users.
        </li>
        <li>
          Designed a forum application where users could create questions, leave
          comments, and upvote these comments. The project was a MERN
          application styled with Bootstrap.
        </li>
      </ul>
      <p>
        As well as gaining real-world experience in the software industry, I
        also improved my soft skills, in particular time-management,
        problem-solving and effective communication.
      </p>
      <h3>Education</h3>
      <h4>University of Birmingham BSc Computer Science</h4>
      <h4>Aylesbury Grammar School — A levels</h4>
      <p>Maths: A*, Further Maths: A*, Computer Science: A*, Physics: A*</p>
      <h5>Skills</h5>
      <ul>
        <li>Languages: Python, Javascript, Java</li>
        <li>Frameworks/Libraries: Node.js, Express, React, Bootstrap</li>
        <li>Data/Tools: MongoDB, PostgreSQL, Git, Docker</li>
      </ul>
      <h3>Achievements</h3>
      <ul>
        <li>Duke of Edinburgh Gold Award Certificate of Achievement</li>
        <li>National Citizen Service</li>
        <li>Numerous performances as a Jazz pianist</li>
        <li>Two games in Apple App Store as a teenager - Through the Gaps and Orbit Walker</li>
      </ul>
      <p>
        Github:{" "}
        <a href="https://github.com/GeorgeCGarman">
          https://github.com/GeorgeCGarman
        </a>
      </p>
    </div>
  )
}

export default CV
